import SEO from '../components/SEO';

const About = () => {
  return (
    <div className="min-h-screen pt-10">
      <SEO 
        title="About Us" 
        description="Learn about the family legacy of SSS Home Painting in Madurai. Over 16 years of experience in high-quality painting services." 
      />
      
      {/* Hero Section */}
      <section className="bg-slate-50 py-16 px-4">
        <div className="max-w-7xl mx-auto flex flex-col items-center text-center">
            <span className="text-orange-600 font-bold tracking-widest uppercase mb-2">Our Story</span>
            <h1 className="text-4xl md:text-5xl font-bold text-blue-900 mb-6">Family Legacy of Excellence</h1>
            <p className="text-lg text-gray-600 max-w-3xl">
                What started as a passion for transforming spaces has grown into a trusted family name in Madurai's painting industry.
            </p>
        </div>
      </section>

      {/* Experience & History */}
      <section className="py-20 px-4 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-bold text-blue-900 mb-6">16+ Years of Craftsmanship</h2>
            <p className="text-gray-600 mb-6 leading-relaxed">
              SSS Home Painting carries a rich legacy of professional painting services. While the "SSS Home Painting" brand has been serving Madurai for 7 successful years, our core team brings over 16 years of collective industry experience.
            </p>
            <p className="text-gray-600 mb-6 leading-relaxed">
              In 2017, we officially established SSS Home Painting with a simple mission: to provide Madurai families and businesses with premium quality painting that lasts for years. We aren't just painters; we are consultants who help you choose the right colors and materials for your dream space.
            </p>
            <div className="grid grid-cols-2 gap-6 mt-8">
              <div className="bg-blue-50 p-6 rounded-xl border-l-4 border-blue-900">
                <p className="text-3xl font-bold text-blue-900">16+</p>
                <p className="text-gray-600 text-sm">Years Experience</p>
              </div>
              <div className="bg-orange-50 p-6 rounded-xl border-l-4 border-orange-600">
                <p className="text-3xl font-bold text-orange-600">500+</p>
                <p className="text-gray-600 text-sm">Projects Completed</p>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
             <div className="bg-gray-200 h-80 rounded-2xl flex items-center justify-center text-gray-400 italic">[Our Work 1]</div>
             <div className="bg-gray-200 h-64 rounded-2xl mt-16 flex items-center justify-center text-gray-400 italic">[Our Work 2]</div>
          </div>
        </div>
      </section>
      
      {/* Values Section */}
      <section className="bg-blue-900 text-white py-20 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-16">Why We Stand Out</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {[
              { 
                title: "Premium Materials", 
                desc: "We use only top-tier paints like Asian Paints and Berger to ensure long-lasting finish." 
              },
              { 
                title: "Punctual Delivery", 
                desc: "We respect your time. Every project we undertake is completed within the promised timeline." 
              },
              { 
                title: "Expert Supervision", 
                desc: "Every stroke is monitored by experts to ensure perfection in every corner." 
              }
            ].map((v, i) => (
              <div key={i} className="bg-blue-800 p-8 rounded-2xl hover:bg-orange-600 transition-all cursor-default">
                <h3 className="text-xl font-bold mb-4">{v.title}</h3>
                <p className="text-blue-100">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
